import React, { useEffect, useState } from 'react';
import styles from './DistributorDetails.module.scss';
import { $t } from "../../helpers/translator";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";
import Tooltip from "../miscellaneous/Tooltip/Tooltip";
import { useDispatch } from "react-redux";
import { FaEdit, FaRegAddressCard } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';
import { AiOutlinePhone } from 'react-icons/ai';
import { BsPersonBoundingBox, BsPerson } from 'react-icons/bs';
import { GiWorld } from 'react-icons/gi';
import Modal from "../miscellaneous/Modal/Modal";
import { getCountries } from "../../store/data-slice";
import _ from "lodash";
import { $validate } from "../../helpers/formValidator";
import api from "../../helpers/api";
import { setAlert } from "../../store/alerts-slice";

import Input from "../miscellaneous/Input/Input";

const DistributorDetails = (props) => {
    const dispatch = useDispatch();

    const [ formSent, setFormSent ] = useState(false)
    const [ countryOptions, setCountryOptions ] = useState([])
    const [ countriesOptionsSelected, setCountryOptionsSelected ] = useState([])
    const [ showDistributorDetailsChangeModal, setDistributorDetailsChangeModal ] = useState(false)
    const [ payload, setPayload ] = useState({
        id: props.user ? props.user.distributor_id : '',
        country_id: props.user ? props.user.country_id : '',
        name: props.user ? props.user.name : '',
        email: props.user ? props.user.email : '',
        phone: props.user ? props.user.phone : '',
        address: props.user ? props.user.address : '',
        country_name: props.user ? props.user.country_name : '',
    });

    const [ distributorData, setDistributorData ] = useState({});

    const [ validations, setValidations ] = useState({
        county_id: {
            rules: [ 'required' ],
            errors: []
        },
        email: {
            rules: [ 'email' ],
            errors: []
        },
        name: {
            rules: [ 'required', 'minLength(3)', 'maxLength(30)', 'name' ],
            errors: []
        },
        phone: {
            rules: [ 'required', 'minLength(9)', 'maxLength(30)', 'id', 'numeric' ],
            errors: []
        },
        address: {
            rules: [ 'required', 'minLength(1)', 'maxLength(30)' ],
            errors: []
        }
    });

    const getCountriesOptions = () => {
        return countryOptions.filter((c) => {
            return Array.isArray(payload.country_id) && payload.country_id.includes(c.id)
        }).map((c) => {
            return {
                label: $t('countries.' + c.name),
                value: c.id
            }
        });
    }

    useEffect(async () => {
        await getDistributorData();
        await getCountriesNew();
    }, [])


    async function getCountriesNew() {
        try {
            let res = await dispatch(getCountries());
            let countries = [ ...res ];
            setCountryOptions(countries);
        } catch (e) {
            console.error('err getting countries,', e);
        }
    }

    function getCountryName() {
        if (distributorData.country_id) {
            let countries = countryOptions.filter(c => distributorData.country_id.includes(c.id)).map((c) => {
                return c.name;
            });

            return countries.join(', ');
        }

        return '';

    }

    async function getDistributorData() {
        try {
            let res = await api.get(`/account/distributor?distributor_id=${props.distributorId}`)
            if (!res || !res.success) {
                return;
            }
            setPayload(res.data.data)
            setDistributorData(res.data.data)

        } catch (e) {
            console.error('err getting distributor,', e);
        }
    }

    function closeModals() {
        setDistributorDetailsChangeModal(false)
    }


    async function formSentClickHandler() {
        setFormSent(true);
        let errorCount = 0;
        _.forEach(payload, (v, k) => {
            if (validations[ k ]) {
                errorCount += validateField(k, v, validations[ k ][ 'rules' ])
            }
        })

        // console.log(errorCount)
        if (!errorCount) {
            try {
                let res = await api.post('/account/distributor', {
                    id: payload.id,
                    email: payload.email,
                    name: payload.name,
                    phone: payload.phone,
                    country_id: payload.country_id,
                    address: payload.address,
                });
                if (res.success) {
                    dispatch(setAlert({ type: 'success' }))
                    closeModals();
                    await getDistributorData();
                    return;
                }
                dispatch(setAlert({ type: 'error' }))
            } catch (e) {
                console.error(e);
            }
        }
    }

    function validateField(id, value, rules) {
        let errorsArr = $validate(value, rules)

        let newValidations = { ...validations }
        newValidations[ id ].errors = errorsArr;
        setValidations(newValidations)

        return errorsArr.length
    }

    function renderChangeAlertName() {
        return (
            <div className={ styles.container }>
                <div className={ 'alma-box-header' }>
                    <div>
                        <h3>{ $t('global.account.changeDistributorDetails') }</h3>
                    </div>
                </div>
                <div className={ 'alma-box-content' }>
                    <div className={ 'alma-fields-row' }>
                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.myDetails.email') }</div>
                            <Input name="email"
                                tooltip={ $t('global.account.contactEmail') }
                                className={ `${'alma-input'}` }
                                type="text"
                                value={ payload.email }
                                placeholder={ payload.email }
                                onChange={ (data) => {
                                    setPayload({ ...payload, email: data.target.value });
                                    validateField('email', data.target.value, validations.email.rules)
                                } } />
                            <div className={ 'alma-field-error' }>{ formSent ? validations.email.errors[ 0 ] : '' }</div>
                        </div>
                    </div>
                    <div className={ 'alma-fields-row' }>
                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.myDetails.fullName') }</div>
                            <Input name="name"
                                tooltip={ $t('global.account.contactName') }
                                className={ `${'alma-input'}` }
                                type="text"
                                value={ payload.name }
                                placeholder={ payload.name }
                                onChange={ (data) => {
                                    setPayload({ ...payload, name: data.target.value });
                                    validateField('name', data.target.value, validations.name.rules)
                                } } />
                            <div className={ 'alma-field-error' }>{ formSent ? validations.name.errors[ 0 ] : '' }</div>
                        </div>
                    </div>
                    <div className={ 'alma-fields-row' }>
                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.account.phone') }</div>
                            <Input name="phone"
                                tooltip={ $t('global.account.contactPhone') }
                                className={ `${'alma-input'}` }
                                type="text"
                                value={ payload.phone }
                                placeholder={ payload.phone }
                                onChange={ (data) => {
                                    setPayload({ ...payload, phone: data.target.value });
                                    validateField('phone', data.target.value, validations.phone.rules)
                                } } />
                            <div className={ 'alma-field-error' }>{ formSent ? validations.phone.errors[ 0 ] : '' }</div>
                        </div>
                    </div>
                    <div className={ 'alma-fields-row' }>
                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.account.country') }</div>
                            <MultiSelect
                                multi={ true }
                                options={ countryOptions }
                                selected={ getCountriesOptions() }
                                onValueChange={ (data) => {
                                    const countryIds = Object.values(data).map((d) => {
                                        return d.value;
                                    })
                                    setPayload({ ...payload, country_id: countryIds });
                                } }
                            />
                        </div>
                    </div>
                    <div className={ 'alma-fields-row' }>
                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.account.address') }</div>
                            <Input name="email"
                                // tooltip={$t('global.staff.cannotChangeStaffClinic')}
                                className={ `${'alma-input'}` }
                                type="text"
                                value={ payload.address }
                                placeholder={ payload.address }
                                onChange={ (data) => {
                                    setPayload({ ...payload, address: data.target.value });
                                    validateField('address', data.target.value, validations.address.rules)
                                } } />
                            <div className={ 'alma-field-error' }>{ formSent ? validations.address.errors[ 0 ] : '' }</div>
                        </div>
                    </div>
                </div>

                <div className={ 'alma-box-footer' }>
                    <div></div>
                    <div className={ 'alma-button' } onClick={ () => formSentClickHandler() }>
                        { props.mode === 'add' ? $t('global.account.changeDistributorDetails') : $t('global.account.changeDistributorDetails') }
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={ `${styles[ 'container' ]} alma-box` }>
            <div className={ `alma-box-header` }>
                <span><h3>{ $t('global.account.distributorDetails') }</h3></span>
                <Tooltip
                    content={ $t('global.account.editData') }>
                    <FaEdit className={ `${styles[ 'edit-icon' ]}` }
                        onClick={ () => setDistributorDetailsChangeModal(true) } />
                </Tooltip>
            </div>
            <div>
                <div className={ `${styles[ 'row' ]}` }>
                    <Tooltip
                        content={ $t('global.account.systemDistributorID') }>
                        <BsPersonBoundingBox className={ `${styles[ 'data-icon' ]}` } />
                    </Tooltip>
                    <div className={ `${styles[ 'header' ]}` }>{ $t('global.account.distributorID') }:</div>
                    <div className={ `${styles[ 'value' ]}` }>{ distributorData.id }</div>

                </div>
                <div className={ `${styles[ 'row' ]}` }>
                    <Tooltip
                        content={ $t('global.account.contactEmail') }>
                        <HiOutlineMail className={ `${styles[ 'data-icon' ]}` } />
                    </Tooltip>
                    <div className={ `${styles[ 'header' ]}` }>{ $t('global.myDetails.email') }:</div>
                    <div className={ `${styles[ 'value' ]}` }>{ distributorData.email }</div>
                </div>
                <div className={ `${styles[ 'row' ]}` }>
                    <Tooltip
                        content={ $t('global.account.contactName') }>
                        <BsPerson className={ `${styles[ 'data-icon' ]}` } />
                    </Tooltip>
                    <div className={ `${styles[ 'header' ]}` }>{ $t('global.myDetails.fullName') }:</div>
                    <div className={ `${styles[ 'value' ]}` }>{ distributorData.name }</div>
                </div>
                <div className={ `${styles[ 'row' ]}` }>
                    <Tooltip
                        content={ $t('global.account.contactPhone') }>
                        <AiOutlinePhone className={ `${styles[ 'data-icon' ]}` } />
                    </Tooltip>
                    <div className={ `${styles[ 'header' ]}` }>{ $t('global.account.phone') }:</div>
                    <div className={ `${styles[ 'value' ]}` }>{ distributorData.phone }</div>
                </div>
                <div className={ `${styles[ 'row' ]}` }>
                    <GiWorld className={ `${styles[ 'data-icon' ]}` } />
                    <div className={ `${styles[ 'header' ]}` }>{ $t('global.account.country') }:</div>
                    <div className={ `${styles[ 'value' ]}` }>{ getCountryName() }</div>
                </div>
                <div className={ `${styles[ 'row' ]}` }>
                    <FaRegAddressCard className={ `${styles[ 'data-icon' ]}` } />
                    <div className={ `${styles[ 'header' ]}` }>{ $t('global.account.address') }:</div>
                    <div className={ `${styles[ 'value' ]}` }>{ distributorData.address }</div>
                </div>
            </div>
            <Modal content={ renderChangeAlertName() }
                onClose={ closeModals.bind(this) }
                visible={ showDistributorDetailsChangeModal } />
        </div>
    );
}

DistributorDetails.defaultProps = {
    user: null,
}

export default DistributorDetails;
